<script>
    import {createEventDispatcher} from "svelte";

    export let rootMessageId;

    const dispatcher = createEventDispatcher();

    function onClick(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        dispatcher("reply", {
            rootMessageId,
            buttonEl: e.target
        })
    }
</script>

<button type="button" class="icon-reply" on:click={onClick}><slot/></button>